export var SettlementStatus;
(function (SettlementStatus) {
    SettlementStatus["Pending"] = "pending";
    SettlementStatus["Done"] = "done";
    SettlementStatus["Cancelled"] = "cancelled";
})(SettlementStatus || (SettlementStatus = {}));
